import React, { useContext } from 'react';
import { Offline } from "../contexts/offlineContext";
import OnlineIcon from '../../images/internet_online_ko_blue.png'
import OfflineIcon from '../../images/internet_offline_ko_blue.png'

export default function StatusIcon() {
    const { offline } = useContext(Offline);

    return (
        <div>
            {(offline === "0") && <img src={OnlineIcon} className="icon" style={{ marginLeft: '10px' }} alt="Online" />}
            {(offline === "1") && <img src={OfflineIcon} className="icon" style={{ marginLeft: '10px' }} alt="Offline" />}
        </div>
    )
}
